import { Box, styled, Typography } from '@mui/material'
import React from 'react'
import Fade from 'react-reveal/Fade';


const About=styled(Box)(({theme})=>({
    display:'flex',
    background:'#f6f6f6',
    height: '500px',
    width:'100%',
    fontSize:'23px',
    [theme.breakpoints.down('md')]:{
      fontSize:'17px',
    }
    
  }))
const Image=styled('img')(({theme})=>({
  display:'block',
  [theme.breakpoints.down('md')]:{
    display:'none',
  }
}))

const Text=styled(Typography)(({theme})=>({
  fontSize:'23px',
  [theme.breakpoints.down('lg')]:{
    fontSize:'17px',
  }
}))

const AboutUs = () => {
  return (
    <About id='About'>
      <Fade left big>
      <Box style={{width:'80%',marginLeft:'44px'}}>
       <h1 style={{color:'#010B30'}} >ABOUT ME :</h1>
        <h2>a little&nbsp;<span style={{color:'#0244BE'}}>about</span>&nbsp;me... </h2>
        <Text style={{fontFamily:"'Lora', serif"}}>My name is Ayush Singh, I am Full Stack Web Developer, and programming enthusiast and a Computer Science student from India. I am pursuing my diploma in Computer Engineering from Ambedkar DSEU Shakarpur Campus.</Text>
        <br/>
        <Text style={{fontFamily:"'Lora', serif"}}>I love working on new and exciting technologies emerging nowadays. I have a good experience as a MERN Stack Developer.</Text>
        <br/>
      <Text style={{fontFamily:"'Lora', serif"}}>Apart from coding I love to play video games ,cricket and basketball. </Text>
      </Box>
      <Box style={{width:'20%',display:'flex',alignItems:'center',justifyContent:'center',marginTop:'-40px'}}>
        <Image  src="https://i.postimg.cc/nc0jVQYq/Ayush-Photo.jpg" style={{width:'193px',borderRadius:'4px',boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",marginLeft:'114px',marginTop:'113px'}} alt=""/>
      </Box>
      </Fade>
    </About>
  )
}

export default AboutUs
